import React, { Dispatch, SetStateAction } from "react";
//react-redux
import toast from "components/Toast/dispatch";
// components
import { CategoryType, CategoryTypeNumber } from "components/TabNavigation/interface";
import { BudgetsSaved } from "../components/LastHits/interface";
// services
import DomainSettingService from "services/domainSetting.service";

const _domainSettingService = new DomainSettingService();

export const getSegmentByCode = (segment: string) => {
  switch (segment) {
    case CategoryType.MEDICINE:
      return CategoryTypeNumber.MEDICINE;
    case CategoryType.MATERIAL:
      return CategoryTypeNumber.MATERIAL;
    case CategoryType.NUTRITION:
      return CategoryTypeNumber.NUTRITION;
    case CategoryType.OUT_PORTFOLIO:
      return CategoryTypeNumber.OUT_PORTFOLIO;
    case CategoryType.DEFAULT:
      return CategoryTypeNumber.DEFAULT;
  }
};

export const capitalizeFirstLetter = (str: string) => {
  const subst = str?.toLowerCase().replace(/(?:^|\s)\S/g, function (letter) { return letter?.toUpperCase(); });
  return subst;
};

export const checkIsBudgetSavedOthersUsers = (
  openModal: Dispatch<SetStateAction<boolean>>,
  savedBudgets: BudgetsSaved[],
  dispatch: Dispatch<any>,
  fullNameUser: string,
  setIsClickButtonFinally?: Dispatch<SetStateAction<boolean>>
) => {
  const userSavedBudget: BudgetsSaved[] = savedBudgets.filter(budget => budget.name !== fullNameUser);

  if (userSavedBudget.length > 0) {
    toast.yesNoCustom(
      'Atenção',
      'Itens salvos por outro usuário serão enviados, deseja continuar?',
      () => {
        dispatch({ type: 'CLOSE_TOAST' });
        openModal(true);
        setIsClickButtonFinally && setIsClickButtonFinally(true);
      },
      undefined,
      undefined,
      'Sim',
      'Não'
    );
  } else {
    openModal(true);
    setIsClickButtonFinally && setIsClickButtonFinally(true);
  }
};

export const getBlockedBranches = async () => {
  const result = await _domainSettingService
    .get(undefined, undefined, 'value asc', {
      and: [
        { identifier: { eq: 'BlockedBranches' } },
        { key: { eq: 'BLOCKED_BRANCHES' } },
        { enabled: { eq: true } },
      ],
    });

  if (result.data.length > 0)
    return result.data[0].value.split(',');

  return [];
};

export const distributionCenterList = [
  "RIB",
  "CAT",
  "LDA",
  "BRA",
  "REC",
  "LAJ",
  "NSR",
  "EPX",
  "T4",
  "PFS",
  "RJ",
  "ES",
  "RN",
  "IND"
];

const sendOrUpdateText = (targetDc: any, distributionCenterSelected: string) => {
  if ((distributionCenterList.includes(targetDc) && distributionCenterSelected !== "default") || targetDc === "default" && distributionCenterSelected !== "default") {
    return "atualizar";
  } else {
    return "enviar";
  }
};

const sendOrUpdateButtonText = (targetDc: any, distributionCenterSelected: string) => {
  if ((distributionCenterList.includes(targetDc) && distributionCenterSelected !== "default") || targetDc === "default" && distributionCenterSelected !== "default") {
    return "Atualizar";
  } else {
    return "Enviar";
  }
};

const handleTargetText = (targetDc: any, distributionCenterSelected: string) => {
  if (targetDc !== "default" && targetDc !== "outPortfolio")
    return (<span>Antes de mudar para o cd de <strong>{targetDc}</strong>, deseja {sendOrUpdateText(targetDc, distributionCenterSelected)}<br /> o orçamento do(s) item(s) que foi(foram) editado(s)?</span>);

  if (targetDc === "default")
    return (<span>Antes de mudar para os itens <strong>Não preenchidos</strong>,<br /> deseja {sendOrUpdateText(targetDc, distributionCenterSelected)} o(s) orçamento(s) que foi(foram) salvo(s)?</span>);
};

const handleActionButton = (handleChangeTab: Function, page: number, filter: string, dispatch: Dispatch<any>, setModalPaymentTermModal: Dispatch<SetStateAction<boolean>>) => {
  handleChangeTab(page, filter);
  dispatch({ type: 'CLOSE_TOAST' });
  setModalPaymentTermModal(true);
};

export const checkDistributionCenterSelected = (
  distributionCenterSelected: string,
  targetDc: string | JSX.Element | JSX.Element[],
  dispatch: Dispatch<any>,
  setModalPaymentTermModal: Dispatch<SetStateAction<boolean>>,
  handleChangeTab: Function,
  page: number,
  filter: string
) => {
  targetDc !== distributionCenterSelected && (
    toast.yesNoCustom(
      "Atenção",
      handleTargetText(targetDc, distributionCenterSelected)!,
      () => { handleActionButton(handleChangeTab, page, filter, dispatch, setModalPaymentTermModal); },
      undefined,
      48,
      sendOrUpdateButtonText(targetDc, distributionCenterSelected),
      'Descartar',
      undefined,
      undefined,
      353,
      undefined,
      undefined,
      () => handleChangeTab(page, filter, true)
    )
  );

};